/**
 * TOTAL NUNCA PARCIAL — o aviso de lista cortada (item 4 do Trilho, 03/09).
 *
 * O servidor corta listas no teto (#134) e, desde hoje, DIZ que cortou pelo cabeçalho
 * `X-Lista-Cortada`; o `apiFetch` transforma isso no evento `lista-cortada`. Este
 * componente mora no Layout e escuta: uma barra dizendo "esta tela mostra só os
 * primeiros N — há mais; refine o filtro". Some ao trocar de rota ou ao fechar.
 *
 * Por que aqui e não em cada página: as páginas de lista (Clientes, A Pagar, A Receber,
 * Pipeline, Prestadores…) estão na dívida de tamanho, e um aviso que precisa de código
 * em cada tela é um aviso que alguma tela vai esquecer.
 */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { EVENTO_LISTA_CORTADA, type ListaCortadaDetalhe } from "../lib/api";

export function AvisoListaCortada() {
  const [corte, setCorte] = useState<ListaCortadaDetalhe | null>(null);
  const { pathname } = useLocation();
  useEffect(() => {
    const ouvir = (e: Event) => setCorte((e as CustomEvent<ListaCortadaDetalhe>).detail);
    window.addEventListener(EVENTO_LISTA_CORTADA, ouvir);
    return () => window.removeEventListener(EVENTO_LISTA_CORTADA, ouvir);
  }, []);
  // Trocou de tela: o aviso era da lista de antes.
  useEffect(() => { setCorte(null); }, [pathname]);
  if (!corte) return null;
  return (
    <div role="status" className="mb-3 flex items-start gap-2 rounded-md border border-[hsl(var(--warn)/0.5)] bg-[hsl(var(--warn-wash))] px-3 py-2 text-[13px]">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--warn))]" />
      <div className="min-w-0 flex-1">
        <b>Esta lista mostra só os primeiros {corte.mostrados.toLocaleString("pt-BR")} — há mais.</b>{" "}
        Os totais que você vê aqui são desses {corte.mostrados.toLocaleString("pt-BR")}, não de tudo. Refine o filtro (busca, status, período) para chegar ao resto.
      </div>
      <button type="button" onClick={() => setCorte(null)} aria-label="fechar aviso" className="text-muted-foreground hover:text-foreground"><X className="h-4 w-4" /></button>
    </div>
  );
}
